import React from "react";
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { route } from "./static/route";

import LoginPage from "./pages/login";
import NotFoundPage from "./pages/notFound";
import DashboardPage from "./pages/dashboard";
import PrivateRoute from "./components/route/PrivateRoute";
import ItemsPage from "./pages/items";
import ProcessesPage from "./pages/processes";
import PartiesPage from "./pages/parties";
import JobworksPartiesPage from "./pages/jobworksParties";
import OrdersPage from "./pages/orders";
import PaymentsPage from "./pages/payments";
import UsersPage from "./pages/users";
import JobworksPage from "./pages/jobworks";
import JobworksPaymentsPage from "./pages/jobworksPayments";
import AccountTypesPage from "./pages/accountTypes";
import AccountsPage from "./pages/accounts";
import EmployeesPage from "./pages/employees";
import SalariesPage from "./pages/salaries";
import SamplesPage from "./pages/samples";
import PurchaseItemsPage from "./pages/purchaseItems";
import PurchasePartiesPage from "./pages/purchaseParties";
import PurchasePaymentsPage from "./pages/purchasePayments";
import PurchasePage from "./pages/purchase";
import PurchaseCreatePage from "./pages/purchase/create";
import PurchaseEditPage from "./pages/purchase/edit";
import ActivityLogsPage from "./pages/activityLogs";

const App = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path={route.login} element={<LoginPage />} />

        <Route
          path={route.dashboard}
          element={
            <PrivateRoute element={<DashboardPage />} path={route.login} />
          }
        />

        <Route
          path={route.items}
          element={<PrivateRoute element={<ItemsPage />} path={route.login} />}
        />

        <Route
          path={route.processes}
          element={
            <PrivateRoute element={<ProcessesPage />} path={route.login} />
          }
        />

        <Route
          path={route.parties}
          element={
            <PrivateRoute element={<PartiesPage />} path={route.login} />
          }
        />

        <Route
          path={route.jobworksParties}
          element={
            <PrivateRoute
              element={<JobworksPartiesPage />}
              path={route.login}
            />
          }
        />

        <Route
          path={route.jobworks}
          element={
            <PrivateRoute element={<JobworksPage />} path={route.login} />
          }
        />

        <Route
          path={route.orders}
          element={<PrivateRoute element={<OrdersPage />} path={route.login} />}
        />

        <Route
          path={route.payments}
          element={
            <PrivateRoute element={<PaymentsPage />} path={route.login} />
          }
        />

        <Route
          path={route.users}
          element={<PrivateRoute element={<UsersPage />} path={route.login} />}
        />

        <Route
          path={route.jobworksPayments}
          element={
            <PrivateRoute
              element={<JobworksPaymentsPage />}
              path={route.login}
            />
          }
        />

        <Route
          path={route.accountTypes}
          element={
            <PrivateRoute element={<AccountTypesPage />} path={route.login} />
          }
        />

        <Route
          path={route.accounts}
          element={
            <PrivateRoute element={<AccountsPage />} path={route.login} />
          }
        />

        <Route
          path={route.employees}
          element={
            <PrivateRoute element={<EmployeesPage />} path={route.login} />
          }
        />

        <Route
          path={route.salaries}
          element={
            <PrivateRoute element={<SalariesPage />} path={route.login} />
          }
        />

        <Route
          path={route.samples}
          element={
            <PrivateRoute element={<SamplesPage />} path={route.login} />
          }
        />

        <Route
          path={route.purchaseItems}
          element={
            <PrivateRoute
              element={<PurchaseItemsPage />}
              path={route.login}
            />
          }
        />

        <Route
          path={route.purchaseParties}
          element={
            <PrivateRoute
              element={<PurchasePartiesPage />}
              path={route.login}
            />
          }
        />

        <Route
          path={route.purchasePayments}
          element={
            <PrivateRoute
              element={<PurchasePaymentsPage />}
              path={route.login}
            />
          }
        />

        <Route
          path={route.purchaseCreate}
          element={
            <PrivateRoute
              element={<PurchaseCreatePage />}
              path={route.login}
            />
          }
        />

        <Route
          path={route.purchaseEdit}
          element={
            <PrivateRoute
              element={<PurchaseEditPage />}
              path={route.login}
            />
          }
        />

        <Route
          path={route.purchase}
          element={
            <PrivateRoute element={<PurchasePage />} path={route.login} />
          }
        />

        <Route
          path={route.activityLogs}
          element={
            <PrivateRoute element={<ActivityLogsPage />} path={route.login} />
          }
        />

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AuthProvider>
  );
};
export default App;
